export default "/assets/profile_pic-feedc4f388091f5635ccdcbca11747fab3ca854b3d15d848a48933735e401374.svg";